// extracted by mini-css-extract-plugin
export default {"gridContent":"SearchIndex_gridContent__thwaW","gridWrapper":"SearchIndex_gridWrapper__G5jAI"};